/* AM-NAV-CATS 2026-08-16
   Nav de CATEGORIAS bajo el logo (paginas de coleccion).
   - Escritorio (>=990px): el desplegable lo abre el :hover por CSS. Este JS no interviene.
   - Movil (<990px): la nav hace scroll horizontal (overflow-x:auto) y recorta cualquier
     panel absoluto, asi que al tocar una categoria copiamos su contenido al contenedor
     .am-cat-mobile que vive DEBAJO de la nav, fuera del scroller.
*/
(function () {
  function init() {
    var nav = document.querySelector('[data-am-catnav]');
    var drop = document.querySelector('.am-cat-mobile');
    if (!nav || !drop || nav.dataset.amCatnavReady === '1') return;
    nav.dataset.amCatnavReady = '1';

    function isMobile() {
      return window.matchMedia('(max-width: 989px)').matches;
    }

    function closeAll() {
      drop.classList.remove('is-open');
      drop.innerHTML = '';
      drop.removeAttribute('data-for');
      Array.prototype.forEach.call(nav.querySelectorAll('.am-cat.is-open'), function (c) {
        c.classList.remove('is-open');
      });
    }

    nav.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.am-cat__btn') : null;
      if (!btn || !isMobile()) return;
      e.preventDefault();
      var cat = btn.parentNode;
      var key = cat.getAttribute('data-cat') || '';
      var wasOpen = drop.classList.contains('is-open') && drop.getAttribute('data-for') === key;
      closeAll();
      if (wasOpen) return;
      var panel = cat.querySelector('.am-cat__panel');
      drop.innerHTML = panel ? panel.innerHTML : '';
      drop.setAttribute('data-for', key);
      drop.classList.add('is-open');
      cat.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    });

    document.addEventListener('click', function (e) {
      if (!isMobile()) return;
      if (!e.target.closest) return;
      if (e.target.closest('[data-am-catnav]') || e.target.closest('.am-cat-mobile')) return;
      closeAll();
    });

    window.addEventListener('resize', function () {
      if (!isMobile()) closeAll();
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
